import { type RouteObject } from 'react-router-dom';

import { ReportsPage } from '~/b4b/features/reports/ReportsPage';
import { urlBuilder } from '~/b4b/utils/urlBuilder';

import { GenerateReportsPage } from '../reports/GenerateReportsPage';

/**
 * SPA route definitions for React Router and AutoLinkContext.
 * These routes will be handled client-side within the SPA.
 */
export const routes: RouteObject[] = [
  {
    path: urlBuilder.reports.path,
    element: <ReportsPage />,
  },
  {
    path: `${urlBuilder.reportsNew.path}/*`,
    element: <GenerateReportsPage />,
  },
];
